import React, { useRef, useState } from 'react';

import {
  useResponsiveParams,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  MixedGridGroup,
  Text,
  Label,
  QuantaInput,
  QuantaInputWrapper,
  QuantaCheckbox,
  Button
} from 'quanta-ui';
import {
  faSearch,
  faSpinner,
  faExclamationTriangle,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@apollo/client';
import { GET_BUY_MOTOR_POLICY_VAR_DETAILS,ZOOP_VERIFY_ENABLE } from '../queries';
// import Loading from '../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import CurrencyFormater from '../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater, useFetchQuery } from 'quanta-flows';
// import { updateBuyMotorPolicy } from '../_graphql/state';
import { updateBuyMotorPolicy } from 'quanta-flows/modules/proposal/motor/state';
import moment from 'moment';
import { VEHICLE_DETAILS } from '../../../../capture-details/motor/carSecure/queries';

export default function VehicleDetails({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  lobCode,
  lobName,
  productCode,
  productType,
  productName,
  ...props
}) {
  
  const fetchQuery = useFetchQuery();
  const [loadingVehicleDetials, setLoadingVehicleDetials] = useState(false);
  const repeatForMobile = 2,
    repeatForDesktop = 3;
  const repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  const initLoadRef = useRef([]);

  const {
    loading: loadingBuyPolicy,
    error: errorBuyPolicy,
    data: dataBuyPolicy,
    previousData,
  } = useQuery(GET_BUY_MOTOR_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: new Set(initLoadRef?.current).size >= 1 ? true : false,
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });
  const { 
    loading: loadingZoopVerifyEnable,
    error: errorZoopVerifyEnable,
    data: ZoopVerifyEnableData,} = useQuery( ZOOP_VERIFY_ENABLE, {
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        domainType:'ZoopVerifyEnable',
      },
    },
  });
  if (loadingBuyPolicy
    || loadingZoopVerifyEnable
  ) {
    return (
      <div className="min-h-screen">
        <Loading customMessage={'Fetching Vehicle Details'} />
      </div>
    );
  }
  if (errorBuyPolicy 
    || errorZoopVerifyEnable
  ) {
    return (
      <div className="min-h-screen">
        <Error error={errorBuyPolicy
          || errorZoopVerifyEnable
        } />
      </div>
    );
  }
  const { buyMotorPolicy } = dataBuyPolicy
    ? dataBuyPolicy
    : previousData;
    
  const ZoopVerifyEnable =ZoopVerifyEnableData?.getDomainData?.[0];
  
  const initialValues = {
    vehicleRegistrationDetails: {
      registrationNumber: buyMotorPolicy?.vehicleTabDetails
        ?.vehicleRegistrationDetails?.registrationNumber
        ? buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumber?.toUpperCase()
        : buyMotorPolicy?.quoteData?.regNo
        ? buyMotorPolicy?.quoteData?.regNo?.toUpperCase()
        : '',
      registrationNumberParts: {
        part1: buyMotorPolicy?.vehicleTabDetails
          ?.vehicleRegistrationDetails?.registrationNumberParts?.part1
          ? buyMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumberParts
              ?.part1?.toUpperCase()
          : buyMotorPolicy?.quoteData?.regNo
          ? buyMotorPolicy?.quoteData?.regNo?.slice(0, 2)?.toUpperCase()
          : buyMotorPolicy?.quoteData?.rtoAuthorityCode
          ? buyMotorPolicy?.quoteData?.rtoAuthorityCode?.slice(0, 2)?.toUpperCase()
          : '',
        part2: buyMotorPolicy?.vehicleTabDetails
          ?.vehicleRegistrationDetails?.registrationNumberParts?.part2
          ? buyMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumberParts
              ?.part2?.toUpperCase()
          : buyMotorPolicy?.quoteData?.regNo
          ? buyMotorPolicy?.quoteData?.regNo?.slice(2, 4)?.toUpperCase()
          : buyMotorPolicy?.quoteData?.rtoAuthorityCode
          ? buyMotorPolicy?.quoteData?.rtoAuthorityCode?.slice(2)?.toUpperCase()
          : '',
        part3: buyMotorPolicy?.vehicleTabDetails
          ?.vehicleRegistrationDetails?.registrationNumberParts?.part3
          ? buyMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumberParts
              ?.part3?.toUpperCase()
          : buyMotorPolicy?.quoteData?.regNo
          ? buyMotorPolicy?.quoteData?.regNo.slice(6,7)?.match(/^[a-zA-Z]/)
          ?buyMotorPolicy?.quoteData?.regNo.slice(4,7)?.toUpperCase()
          :
          buyMotorPolicy?.quoteData?.regNo?.slice(4,6)?.toUpperCase()
          : '',
        part4: buyMotorPolicy?.vehicleTabDetails
          ?.vehicleRegistrationDetails?.registrationNumberParts?.part4
          ? buyMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumberParts
              ?.part4?.toUpperCase()
          : buyMotorPolicy?.quoteData?.regNo
          ? buyMotorPolicy?.quoteData?.regNo.slice(6,7)?.match(/^[a-zA-Z]/)
            ? buyMotorPolicy?.quoteData?.regNo?.slice(7)?.toUpperCase()
          :buyMotorPolicy?.quoteData?.regNo?.slice(6)?.toUpperCase()
          : '',
      },
      isNewVehicle: buyMotorPolicy?.vehicleTabDetails
        ?.vehicleRegistrationDetails?.isNewVehicle
        ? buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.isNewVehicle
        : false,
      engineNumber: buyMotorPolicy?.vehicleTabDetails
        ?.vehicleRegistrationDetails?.engineNumber
        ? buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.engineNumber
        : buyMotorPolicy?.quoteData?.engineNo
        ? buyMotorPolicy?.quoteData?.engineNo
        : '',
      chasisNumber: buyMotorPolicy?.vehicleTabDetails
        ?.vehicleRegistrationDetails?.chasisNumber
        ? buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.chasisNumber
        : buyMotorPolicy?.quoteData?.chasisNo
        ? buyMotorPolicy?.quoteData?.chasisNo
        : '',
        preInspectionNumber: buyMotorPolicy?.vehicleTabDetails
        ?.vehicleRegistrationDetails?.preInspectionNumber
        ? buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.preInspectionNumber
        : buyMotorPolicy?.quoteData?.preInspectionNumber
        ? buyMotorPolicy?.quoteData?.preInspectionNumber
        : '',
      vehicleCategory: buyMotorPolicy?.vehicleTabDetails
        ?.vehicleRegistrationDetails?.vehicleCategory
        ? buyMotorPolicy?.vehicleTabDetails
          ?.vehicleRegistrationDetails?.vehicleCategory : '',
      isProposalRegNoVerified: buyMotorPolicy?.proposalNumber?.length === 0 
        ? null
        : buyMotorPolicy?.vehicleTabDetails
          ?.vehicleRegistrationDetails?.isProposalRegNoVerified,
      proceedWORegNoVerify: false
    },
    vehicleDetails: {
      make: {
        code: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.make
          ?.code
          ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.make
              ?.code
          : buyMotorPolicy?.quoteData?.make?.code
          ? buyMotorPolicy?.quoteData?.make?.code
          : '',
        value: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.make
          ?.value
          ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.make
              ?.value
          : buyMotorPolicy?.quoteData?.make?.code
          ? buyMotorPolicy?.quoteData?.make?.value
          : '',
      },
      model: {
        code: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.model
          ?.code
          ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.model
              ?.code
          : buyMotorPolicy?.quoteData?.model?.code
          ? buyMotorPolicy?.quoteData?.model?.code
          : '',
        value: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
          ?.model?.value
          ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.model
              ?.value
          : buyMotorPolicy?.quoteData?.model?.value
          ? buyMotorPolicy?.quoteData?.model?.value
          : '',
      },
      variant: {
        code: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
          ?.variant?.code
          ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.variant
              ?.code
          : buyMotorPolicy?.quoteData?.variant?.code
          ? buyMotorPolicy?.quoteData?.variant?.code
          : '',
        value: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
          ?.variant?.value
          ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.variant
              ?.value
          : buyMotorPolicy?.quoteData?.variant?.value
          ? buyMotorPolicy?.quoteData?.variant?.value
          : '',
      },
      fuelType: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
        ?.fuelType
        ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.fuelType
        : buyMotorPolicy?.quoteData?.fuelType
        ? buyMotorPolicy?.quoteData?.fuelType
        : '',
      cubeCapacity: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
        ?.cubeCapacity
        ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.cubeCapacity
        : buyMotorPolicy?.quoteData?.cubeCapacity
        ? buyMotorPolicy?.quoteData?.cubeCapacity
        : '',
      seatingCapacity: buyMotorPolicy?.vehicleTabDetails
        ?.vehicleDetails?.seatingCapacity
        ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.seatingCapacity
        : buyMotorPolicy?.quoteData?.seatingCapacity
        ? buyMotorPolicy?.quoteData?.seatingCapacity
        : '',
      yearOfManufacture: buyMotorPolicy?.vehicleTabDetails
        ?.vehicleDetails?.yearOfManufacture
        ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.yearOfManufacture
        : buyMotorPolicy?.quoteData?.yearOfManufacture
        ? buyMotorPolicy?.quoteData?.yearOfManufacture
        : '',
      rtoDetails: {
        rtoAuthorityCode: buyMotorPolicy?.vehicleTabDetails
          ?.vehicleDetails?.rtoDetails?.rtoAuthorityCode
          ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.rtoDetails?.rtoAuthorityCode
          : buyMotorPolicy?.quoteData?.rtoAuthorityCode
          ? buyMotorPolicy?.quoteData?.rtoAuthorityCode
          : '',
        rtoLocationCode: buyMotorPolicy?.vehicleTabDetails
          ?.vehicleDetails?.rtoDetails?.rtoLocationCode
          ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.rtoDetails?.rtoLocationCode
          : buyMotorPolicy?.quoteData?.rtoLocationCode
          ? buyMotorPolicy?.quoteData?.rtoLocationCode
          : '',
        rtoLocationDesc: buyMotorPolicy?.vehicleTabDetails
          ?.vehicleDetails?.rtoDetails?.rtoLocationDesc
          ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.rtoDetails?.rtoLocationDesc
          : buyMotorPolicy?.quoteData?.rtoLocationDesc
          ? buyMotorPolicy?.quoteData?.rtoLocationDesc
          : '',
      },
      dateOfRegistration: buyMotorPolicy?.vehicleTabDetails
        ?.vehicleDetails?.dateOfRegistration
        ? buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.dateOfRegistration
        : buyMotorPolicy?.quoteData?.dateOfReg
        ? buyMotorPolicy?.quoteData?.dateOfReg
        : '',
    },
    insuredDeclaredDetails: {
      vehicleIDV:
        buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails
          ?.vehicleIDV !== null
          ? buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails
              ?.vehicleIDV
          : buyMotorPolicy?.quoteData?.changedIDV !== null
          ? buyMotorPolicy?.quoteData?.changedIDV
          : null,
      irfAdjustmentPercent: buyMotorPolicy?.vehicleTabDetails
        ?.insuredDeclaredDetails?.irfAdjustmentPercent
        ? buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails
            ?.irfAdjustmentPercent
        : buyMotorPolicy?.quoteData?.adjustmentIRF
        ? buyMotorPolicy?.quoteData?.adjustmentIRF
        : '',
    },
  };

  const validate = (values) => {
    let errors = {};
    errors.vehicleRegistrationDetails = {};
    if (!values?.vehicleRegistrationDetails?.chasisNumber) {
      errors.vehicleRegistrationDetails.chasisNumber = '* Required';
    }
    if (buyMotorPolicy?.quoteData?.productCode?.toString()!=='3176'&&buyMotorPolicy?.businessType?.toLowerCase()==='roll over'
    ){
    if (!values?.vehicleRegistrationDetails?.preInspectionNumber&& buyMotorPolicy?.quoteData?.businessType?.toString()?.toLowerCase()!=='new business') {
     if (moment(new Date(), 'DD/MM/YYYY').diff(moment(buyMotorPolicy?.quoteData?.policyExpiryDate, "DD/MM/YYYY"), 'days') >= 91) {
      errors.vehicleRegistrationDetails.preInspectionNumber = '* Required';
        }
    }
    if (!values?.vehicleRegistrationDetails?.preInspectionNumber&& buyMotorPolicy?.quoteData?.businessType?.toString()?.toLowerCase()!=='new business') {
      if((moment(buyMotorPolicy?.quoteData?.policyExpiryDate,
        "DD/MM/YYYY").isBefore(moment(new Date(), 'DD/MM/YYYY'))
        // &&moment(new Date(), 'DD/MM/YYYY').diff(moment(buyMotorPolicy?.quoteData?.policyExpiryDate,"DD/MM/YYYY"),'days')!=1
        && moment(new Date(), 'DD/MM/YYYY').diff(moment(buyMotorPolicy?.quoteData?.policyExpiryDate,"DD/MM/YYYY"),'days')!=0))
        {
      errors.vehicleRegistrationDetails.preInspectionNumber = '* Required';
        }
    }
    if(buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toString()?.toLowerCase()=='no'&& 
    buyMotorPolicy?.quoteData?.businessType?.toString()?.toLowerCase()!=='new business'
        && !values?.vehicleRegistrationDetails?.preInspectionNumber) {
      errors.vehicleRegistrationDetails.preInspectionNumber ='* Required';
    }
  
    }
    if (buyMotorPolicy?.businessType?.toLowerCase() === 'used car' && !values?.vehicleRegistrationDetails?.preInspectionNumber) {
      errors.vehicleRegistrationDetails.preInspectionNumber ='* Required';

    }
    if (!values?.vehicleRegistrationDetails?.engineNumber) {
      errors.vehicleRegistrationDetails.engineNumber = '* Required';
    }
    // if ( buyMotorPolicy?.quoteData?.businessType?.toLowerCase() ===
    // 'new business'&&values?.vehicleRegistrationDetails?.engineNumber?.length<17 ) {
    //   errors.vehicleRegistrationDetails.engineNumber = '* Minimum 17 characters Required';
    // }
    if (values?.vehicleRegistrationDetails?.engineNumber?.length<6 ) {
      errors.vehicleRegistrationDetails.engineNumber = '* Minimum 6 characters Required';
    }
    if ( buyMotorPolicy?.quoteData?.businessType?.toLowerCase() !==
    'new business'&& values?.vehicleRegistrationDetails?.chasisNumber?.length < 6) {
      errors.vehicleRegistrationDetails.chasisNumber =
        '* Minimum 6 characters Required';
    }
    // if (values?.vehicleRegistrationDetails?.engineNumber&&
    //   !values?.vehicleRegistrationDetails?.engineNumber.match(/^[a-zA-Z0-9]+$/)) {
    //   errors.vehicleRegistrationDetails.engineNumber = '* Engine Number cannot contain special characters';
    // }
    if (values?.vehicleRegistrationDetails?.chasisNumber&&
      !values?.vehicleRegistrationDetails?.chasisNumber.match(/^[a-zA-Z0-9~#$*-]+$/)) {
      errors.vehicleRegistrationDetails.chasisNumber = '* Chassis Number cannot contain special characters';
    }
    if ( buyMotorPolicy?.quoteData?.businessType?.toLowerCase() ===
    'new business'&& values?.vehicleRegistrationDetails?.chasisNumber?.length < 17) {
      errors.vehicleRegistrationDetails.chasisNumber =
        '* Minimum 17 characters Required';
    }
    if (
      buyMotorPolicy?.quoteData?.businessType?.toLowerCase() ===
        'new business' &&
      values?.vehicleRegistrationDetails?.isNewVehicle === false
    ) {
      if (
        !values?.vehicleRegistrationDetails?.registrationNumberParts
          ?.part1 ||
        !values?.vehicleRegistrationDetails?.registrationNumberParts
          ?.part2
        ||
        // !values?.vehicleRegistrationDetails?.registrationNumberParts
        //   ?.part3 ||
        !values?.vehicleRegistrationDetails?.registrationNumberParts
          ?.part4
        // !values?.vehicleRegistrationDetails?.registrationNumber
      ) {
        errors.vehicleRegistrationDetails.registrationNumber =
          '* Required';
      }
      if (values?.vehicleRegistrationDetails?.registrationNumberParts
          ?.part2?.toLowerCase() !== 'bh' && 
        ( values?.vehicleRegistrationDetails?.registrationNumberParts
          ?.part1 ||
        values?.vehicleRegistrationDetails?.registrationNumberParts
          ?.part2 ||
        values?.vehicleRegistrationDetails?.registrationNumberParts
          ?.part3 ||
        values?.vehicleRegistrationDetails?.registrationNumberParts
          ?.part4  ) 
      ) {
        let stateCode = /^([a-zA-Z]){2}?$/;
        let distCode = /^([0-9]){2}?$/;
        // let uniqueCode = /^([a-zA-Z]){}?$/;
        // let uniqueCode = /^([a-zA-Z]){3}?$/;
        let uniqueCode = /^[A-Za-z\s]*$/
        let uniqueNumber = /^([0-9]){4}?$/;
        if (
          !values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part1 &&
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part2 &&
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part3 &&
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part4
        ) {
          errors.vehicleRegistrationDetails.registrationNumber =
            '* State Code is Required';
        }
        if (
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part1 &&
          !stateCode.test(
            values?.vehicleRegistrationDetails
              ?.registrationNumberParts?.part1,
          )
        ) {
          errors.vehicleRegistrationDetails.registrationNumber =
            '* Enter valid State or Union Territory Code';
        }
        if (
          !values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part2 &&
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part1 &&
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part3 &&
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part4
        ) {
          errors.vehicleRegistrationDetails.registrationNumber =
            '* District Sequential Number is Required';
        }
        if (
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part2
        ) {
          if (
            !distCode.test(
              values?.vehicleRegistrationDetails
                ?.registrationNumberParts?.part2,
            )
          ) {
            errors.vehicleRegistrationDetails.registrationNumber =
              '* Enter valid District Sequential Number';
          }
        }
        // if (
        //   // !values?.vehicleRegistrationDetails?.registrationNumberParts
        //   //   ?.part3 &&
        //   values?.vehicleRegistrationDetails?.registrationNumberParts
        //     ?.part1 &&
        //   values?.vehicleRegistrationDetails?.registrationNumberParts
        //     ?.part2 &&
        //   values?.vehicleRegistrationDetails?.registrationNumberParts
        //     ?.part4
        // ) {
        //   errors.vehicleRegistrationDetails.registrationNumber =
        //     '* Unique Code is Required';
        // }
        if (
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part3
        ) {
          if (!values?.vehicleRegistrationDetails
            ?.registrationNumberParts?.part3?.match(/^[a-zA-Z]/)
          ) {
            errors.vehicleRegistrationDetails.registrationNumber =
              '* Unique Code cannot be alphanumeric';
          }
        }
        if (
          !values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part4 &&
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part1 &&
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part2 &&
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part3
        ) {
          errors.vehicleRegistrationDetails.registrationNumber =
            '* Unique Number is Required';
        }
        if (
          values?.vehicleRegistrationDetails?.registrationNumberParts
            ?.part4
        ) {
          if (
            !uniqueNumber.test(
              values?.vehicleRegistrationDetails
                ?.registrationNumberParts?.part4,
            )
          ) {
            errors.vehicleRegistrationDetails.registrationNumber =
              '* Unique Number can be only Digits';
          }
        }
      }
    }
    if(( !values?.vehicleRegistrationDetails?.proceedWORegNoVerify
      && !values?.vehicleRegistrationDetails?.isProposalRegNoVerified)
      && (buyMotorPolicy?.proposalNumber?.length === 0 )
      && ZoopVerifyEnable?.value?.toString()?.toLowerCase() === 'yes'
      && values?.vehicleRegistrationDetails?.isNewVehicle === false
    ){
      errors.vehicleRegistrationDetails.isProposalRegNoVerified 
      = "Please verify the Registration Number before proceeding."
    }
    if (Object.keys(errors.vehicleRegistrationDetails).length === 0) {
      errors = {};
    }
    return errors;
  };

  const VehicleDetailsForm = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const [previousRegNoValues, setPreviousPartValues] = useState({
      part1: '',
      part2: '',
      part3: '',
      part4: '',
    });
    const verifyRegNo = async (values) => {
      try {
        const flaDetails = fetchQuery({
          query: VEHICLE_DETAILS,
          fetchPolicy: 'network-only',
          variables: {
            input: {
              regNo: buyMotorPolicy?.quoteData?.regNo,
              rtoAuthCode: values?.vehicleDetails?.rtoDetails?.rtoAuthorityCode 
                ? values?.vehicleDetails?.rtoDetails?.rtoAuthorityCode 
                : buyMotorPolicy?.quoteData?.rtoAuthorityCode,
              productCode: buyMotorPolicy?.quoteData?.productCode?.toString()?.toLowerCase(),
            },
          },
        });
        setLoadingVehicleDetials(true);
        const { data } = await flaDetails;
        const { getVehicleDetails } = data;
        setLoadingVehicleDetials(false);
        return getVehicleDetails;
      } catch (error) {
        setLoadingVehicleDetials(false);
        throw error;
      }
    }
    const data = [
      {
        title: 'Vehicle Registration',
        grid_data: [
          {
            type: 'render',
            className:'mt-2',
            colSpan: repeat === repeatForMobile ? 2 : 1,
            component: (_) => {
              return (
                <>
                  <Text className="flex space-x-6 ">
                    {buyMotorPolicy?.quoteData?.regNo ||
                    values?.vehicleRegistrationDetails?.isNewVehicle ? (
                        <Text className="flex space-x-6 mt-4">
                          <Label
                            text={'Registration Number'}
                            severity={'info'}
                            type={'label'}
                          >
                            {
                              values?.vehicleRegistrationDetails
                                ?.registrationNumber?.toUpperCase()
                            }
                          </Label>
                          
                        </Text>
                    ) : (
                      <QuantaInputWrapper
                        label={<>
                          <Text type={'label'}>Registration Number</Text>
                          <Text severity="error"> *</Text>
                        </>}
                        name="vehicleRegistrationDetails.registrationNumber"
                        size="full"
                        disabled = {buyMotorPolicy?.proposalNumber?.length>0 
                          && !buyMotorPolicy?.isProposalModify}
                        className={(buyMotorPolicy?.proposalNumber?.length>0 
                            && !buyMotorPolicy?.isProposalModify ) ?`border-neutral-dark`:``}
                        fields={[
                          'vehicleRegistrationDetails.registrationNumberParts.part1',
                          'vehicleRegistrationDetails.registrationNumberParts.part2',
                          'vehicleRegistrationDetails.registrationNumberParts.part3',
                          'vehicleRegistrationDetails.registrationNumberParts.part4',
                        ]}
                      >
                        <QuantaInput
                          name="vehicleRegistrationDetails.registrationNumberParts.part1"
                          maxLength="2"
                          size="full"
                          type="text"
                          placeholder="MH"
                          noerror
                          className="uppercase"
                          disabled = {buyMotorPolicy?.proposalNumber?.length>0
                            && !buyMotorPolicy?.isProposalModify }
                          onKeyUp={(e) => {
                            if (e.target.value.length === 2) {
                              document
                                .getElementsByName(
                                  'vehicleRegistrationDetails.registrationNumberParts.part2',
                                )
                                .forEach((e) => e.focus());
                            }
                          }}
                          onDataChange={(val, setFieldValue) => {
                            setFieldValue(
                              `vehicleRegistrationDetails.registrationNumberParts.part1`,
                              val?.toString()?.toUpperCase(),
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.isProposalRegNoVerified`,
                             null,
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.proceedWORegNoVerify`,
                              false,
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.engineNumber`,
                              '',
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.chasisNumber`,
                              '',
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.vehicleCategory`,
                              '',
                            );
                          }}
                        />
                        <span className={`flex items-center font-bold h-12 ${
                          (buyMotorPolicy?.proposalNumber?.length>0
                          && !buyMotorPolicy?.isProposalModify) ?'bg-neutral-light opacity-50':''}`}>
                          -
                        </span>
                        <QuantaInput
                          name="vehicleRegistrationDetails.registrationNumberParts.part2"
                          maxLength="2"
                          size="full"
                          type="text"
                          placeholder="01"
                          noerror
                          disabled = {buyMotorPolicy?.proposalNumber?.length>0
                            && !buyMotorPolicy?.isProposalModify}
                          onKeyUp={(e) => {
                            if (e.target.value.length === 2) {
                              document
                                .getElementsByName(
                                  'vehicleRegistrationDetails.registrationNumberParts.part3',
                                )
                                .forEach((e) => e.focus());
                            }
                          }}
                          onDataChange={(val, setFieldValue) => {
                            setFieldValue(
                              `vehicleRegistrationDetails.isProposalRegNoVerified`,
                             null,
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.proceedWORegNoVerify`,
                              false,
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.engineNumber`,
                              '',
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.chasisNumber`,
                              '',
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.vehicleCategory`,
                              '',
                            );
                          }}
                        />
                        <span className={`flex items-center font-bold h-12 ${
                          (buyMotorPolicy?.proposalNumber?.length>0 
                            && !buyMotorPolicy?.isProposalModify )
                          ?'bg-neutral-light opacity-50':''}`}>
                          -
                        </span>
                        <QuantaInput
                          name="vehicleRegistrationDetails.registrationNumberParts.part3"
                          maxLength="3"
                          size="full"
                          type="text"
                          placeholder="CRS"
                          noerror
                          className="uppercase"
                          disabled = {buyMotorPolicy?.proposalNumber?.length>0
                            && !buyMotorPolicy?.isProposalModify}
                          onKeyUp={(e) => {
                            if (e.target.value.length === 3) {
                              document
                                .getElementsByName(
                                  'vehicleRegistrationDetails.registrationNumberParts.part4',
                                )
                                .forEach((e) => e.focus());
                            }
                          }}
                          onDataChange={(val, setFieldValue) => {
                            setFieldValue(
                              `vehicleRegistrationDetails.registrationNumberParts.part3`,
                              val?.toString()?.toUpperCase(),
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.isProposalRegNoVerified`,
                             null,
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.proceedWORegNoVerify`,
                              false,
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.engineNumber`,
                              '',
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.chasisNumber`,
                              '',
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.vehicleCategory`,
                              '',
                            );
                          }}
                        />
                        <span className={`flex items-center font-bold h-12 ${
                          (buyMotorPolicy?.proposalNumber?.length>0
                            && !buyMotorPolicy?.isProposalModify)
                          ?'bg-neutral-light opacity-50':''}`}>
                          -
                        </span>
                        <QuantaInput
                          name="vehicleRegistrationDetails.registrationNumberParts.part4"
                          maxLength="4"
                          size="full"
                          type="text"
                          placeholder="2845"
                          onDataChange={(val, setFieldValue) => {
                            setFieldValue(
                              `vehicleRegistrationDetails.isProposalRegNoVerified`,
                             null,
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.proceedWORegNoVerify`,
                              false,
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.engineNumber`,
                              '',
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.chasisNumber`,
                              '',
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.vehicleCategory`,
                              '',
                            );
                          }}
                          disabled = {buyMotorPolicy?.proposalNumber?.length>0
                            && !buyMotorPolicy?.isProposalModify}
                          noerror
                        />
                      </QuantaInputWrapper>
                    )}
                    {/* CR P3_058 - Pt1: verify button added to Validate RegNo through Zoop Service */}
                    {ZoopVerifyEnable?.value?.toString()?.toLowerCase() === 'yes'
                    && values?.vehicleRegistrationDetails?.isNewVehicle === false
                      ? (
                        <Text className="flex space-x-6 mt-4">
                          <Button
                            disabled={loadingVehicleDetials || 
                              (buyMotorPolicy?.proposalNumber?.length > 0
                                && !buyMotorPolicy?.isProposalModify )
                            }
                            flat={false}
                            type="button"
                            className="w-30 h-10 space-x-2"
                            iconPre={
                              loadingVehicleDetials ? (
                                <FontAwesomeIcon
                                  icon={faSpinner} spin={true} />
                              ) : values?.vehicleRegistrationDetails?.isProposalRegNoVerified === false ? (
                                <FontAwesomeIcon icon={faExclamationTriangle} />
                              ) : values?.vehicleRegistrationDetails?.isProposalRegNoVerified ? (
                                <FontAwesomeIcon icon={faCheck} />
                              ) : (
                                <FontAwesomeIcon icon={faSearch} />
                              )
                            }
                            onClick={async (_) => {
                              try {
                                setParentAlerts([]);
                                setFieldValue(
                                  `vehicleRegistrationDetails.proceedWORegNoVerify`,
                                  false,
                                );
                                if (buyMotorPolicy?.quoteData?.regNo 
                                  // ||values?.vehicleRegistrationDetails?.isNewVehicle === false
                                ) {
                                    const getVehicleDetails = await verifyRegNo(values);
                                    if(getVehicleDetails) {
                                      setFieldValue(
                                        `vehicleRegistrationDetails.vehicleCategory`,
                                      '',
                                      );
                                      setFieldValue(
                                        `vehicleRegistrationDetails.isProposalRegNoVerified`,
                                      true,
                                      );
                                      setFieldValue(
                                        `vehicleRegistrationDetails.engineNumber`,
                                        getVehicleDetails?.engineNumber,
                                      );
                                      setFieldValue(
                                        `vehicleRegistrationDetails.chasisNumber`,
                                        getVehicleDetails?.chasisNumber,
                                      );
                                      setFieldValue(
                                        `vehicleRegistrationDetails.vehicleCategory`,
                                        getVehicleDetails?.vehicleCategory,
                                      );
                                    }
                                    
                                } else {
                                  if ( !values?.vehicleRegistrationDetails.registrationNumberParts.part1 
                                    || !values?.vehicleRegistrationDetails.registrationNumberParts.part2
                                    || !values?.vehicleRegistrationDetails.registrationNumberParts.part4
                                  ) {
                                    throw new Error(`Please fill the registration Details.`);
                                  } else {
                                    const getVehicleDetails = await verifyRegNo(values);
                                    if (getVehicleDetails) {
                                      setFieldValue(
                                        `vehicleRegistrationDetails.vehicleCategory`,
                                        '',
                                      );
                                      setFieldValue(
                                        `vehicleRegistrationDetails.isProposalRegNoVerified`,
                                        true,
                                      );
                                      setFieldValue(
                                        `vehicleRegistrationDetails.engineNumber`,
                                        getVehicleDetails?.engineNumber,
                                      );
                                      setFieldValue(
                                        `vehicleRegistrationDetails.chasisNumber`,
                                        getVehicleDetails?.chasisNumber,
                                      );
                                      setFieldValue(
                                        `vehicleRegistrationDetails.vehicleCategory`,
                                        getVehicleDetails?.vehicleCategory,
                                      );
                                    }
                                  }
                                }
                              } catch (error) {
                                setFieldValue(
                                  `vehicleRegistrationDetails.isProposalRegNoVerified`,
                                  false,
                                );
                                setFieldValue(
                                  `vehicleRegistrationDetails.engineNumber`,
                                  '',
                                );
                                setFieldValue(
                                  `vehicleRegistrationDetails.chasisNumber`,
                                  '',
                                );
                                setFieldValue(
                                  `vehicleRegistrationDetails.vehicleCategory`,
                                  '',
                                );
                                setLoadingVehicleDetials(false);
                                if( error?.message?.search("This is not Private Car registration number") === -1 
                                && error?.message?.search("We couldn't find any vehicle") === -1 ){
                                  setFieldValue(
                                    `vehicleRegistrationDetails.proceedWORegNoVerify`,
                                    true,
                                  );
                                  // values?.vehicleRegistrationDetails?.proceedWORegNoVerify
                                }
                                setFieldValue(
                                  `vehicleRegistrationDetails.isProposalRegNoVerified`,
                                 false,
                                );
                               
                                let err = error?.message?.search("This is not Private Car registration number") !== -1
                                  ? `This is not Private Car registration number. Please check the deatils.`
                                  : error?.message?.search("We couldn't find any vehicle") !== -1
                                    ? `We couldn't find any vehicle details. Please check the deatils.`
                                    : error?.message;
                                setParentAlerts([
                                  {
                                    id: Date.now(),
                                    header: 'Error in Reg No Verification',
                                    content: (
                                      <div className="flex flex-col w-full h-full mt-2">
                                        <Text type="normal">{err }</Text>
                                      </div>
                                    ),
                                    type: 'error',
                                    timeout: null,
                                    disableClose: false,
                                  },
                                ]);
                              }
                            }}
                          >
                            {loadingVehicleDetials ? (
                              <span className="text-base">Verifying</span>
                            ) : values?.vehicleRegistrationDetails?.isProposalRegNoVerified === false ? (
                              <span className="text-base">Not Verified</span>
                            ) :  values?.vehicleRegistrationDetails?.isProposalRegNoVerified ? (
                              <span className="text-base">Verified</span>
                            ) : (
                              <span className="text-base">Verify</span>
                            )}
                          </Button>
                        </Text>
                      ):null
                    }
                  </Text>
                </>
              );
            },
          },
          !buyMotorPolicy?.quoteData?.regNo
            ? {
                type: 'render',
                colSpan: 2,
                component: (_) => {
                  return (
                    <Text className="flex flex-col justify-center h-full">
                      <Text>
                        <QuantaCheckbox
                          name={
                            'vehicleRegistrationDetails.isNewVehicle'
                          }
                          label={'New Vehicle'}
                          disabled={buyMotorPolicy?.proposalNumber?.length>0
                            && !buyMotorPolicy?.isProposalModify}
                          onDataChange={(val, setFieldValue) => {
                            if (val) {
                              setPreviousPartValues({
                                ...values?.vehicleRegistrationDetails
                                  ?.registrationNumberParts,
                              });
                            }
                            setFieldValue(
                              `vehicleRegistrationDetails.registrationNumber`,
                              val ? 'NEW' : '',
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.registrationNumberParts`,
                              {
                                part1: val
                                  ? ''
                                  : previousRegNoValues?.part1,
                                part2: val
                                  ? ''
                                  : previousRegNoValues?.part2,
                                part3: val
                                  ? ''
                                  : previousRegNoValues?.part3,
                                part4: val
                                  ? ''
                                  : previousRegNoValues?.part4,
                              },
                            );
                            setFieldValue(
                              `vehicleRegistrationDetails.isProposalRegNoVerified`,
                              null,
                            );
                          }}
                        />
                      </Text>
                    </Text>
                  );
                },
              }
            : null,
          // {
          //   type: 'checkbox',
          //   name: 'vehicleRegistrationDetails.isNewVehicle',
          //   label: 'New Vehicle',
          //   colSpan: repeat === repeatForDesktop ? 2:1,
          //   onDataChange: (val,setFieldValue) => {
          //     setFieldValue(`vehicleRegistrationDetails.registrationNumber`,val?'NEW':'');
          //     setFieldValue(`vehicleRegistrationDetails.registrationNumberParts`,{
          //       part1: '',
          //       part2: '',
          //       part3: '',
          //       part4: ''
          //     });
          //   }
          // }:null,
          {
            type: 'text',
            disabled: buyMotorPolicy?.proposalNumber?.length>0
            && !buyMotorPolicy?.isProposalModify,
            colSpan: repeat === repeatForMobile ? 2 : 1,
            name: 'vehicleRegistrationDetails.engineNumber',
            maxLength:17,
            label: (<>
                    <Text type={'label'}>Engine Number</Text>
                    <Text severity="error"> *</Text>
                  </>
            ),
          },
          {
            type: 'text',
            disabled: buyMotorPolicy?.proposalNumber?.length>0
            && !buyMotorPolicy?.isProposalModify,
            colSpan: repeat === repeatForMobile ? 2 : 1,
            name: 'vehicleRegistrationDetails.chasisNumber',
            maxLength:30,
            label: (<>
                    <Text type={'label'}>Chassis Number</Text>
                    <Text severity="error"> *</Text>
                  </>
            ),
          },
          (buyMotorPolicy?.quoteData?.productCode?.toString()!=='3176')&&(buyMotorPolicy?.businessType?.toLowerCase()==='roll over'||buyMotorPolicy?.businessType?.toLowerCase() === 'used car')
            ?
          {
            type: 'text',
            disabled: buyMotorPolicy?.proposalNumber?.length>0
            && !buyMotorPolicy?.isProposalModify,
            colSpan: repeat === repeatForMobile ? 2 : 1,
            name: 'vehicleRegistrationDetails.preInspectionNumber',
            maxLength:17,
              label: 
              (buyMotorPolicy?.quoteData?.businessType?.toLowerCase() === 'roll over')&&
            (moment(new Date(), 'DD/MM/YYYY').diff(moment(buyMotorPolicy?.quoteData?.policyExpiryDate,"DD/MM/YYYY"), 'days') >= 91
        ) ||(buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toString()?.toLowerCase()=='no'&& buyMotorPolicy?.quoteData?.businessType?.toString()?.toLowerCase()!=='new business')
        ||((moment(buyMotorPolicy?.quoteData?.policyExpiryDate,
          "DD/MM/YYYY").isBefore(moment(new Date(), 'DD/MM/YYYY')))
                    // && (moment(new Date(), 'DD/MM/YYYY').diff(moment(buyMotorPolicy?.quoteData?.policyExpiryDate, "DD/MM/YYYY"), 'days') != 1)
        && moment(new Date(), 'DD/MM/YYYY').diff(moment(buyMotorPolicy?.quoteData?.policyExpiryDate,"DD/MM/YYYY"),'days')!=0)
            ? (   <>
                    <Text type={'label'}>Pre Inspection Number</Text>
                    <Text severity="error"> *</Text>
                  </>
            )
            : (<>
                <Text type={'label'}>Pre Inspection Number</Text>
                    </>
              ),
            }
            :buyMotorPolicy?.businessType?.toLowerCase() === 'used car'
            ?{
              type: 'text',
              disabled: buyMotorPolicy?.proposalNumber?.length>0
              && !buyMotorPolicy?.isProposalModify,
              colSpan: repeat === repeatForMobile ? 2 : 1,
              name: 'vehicleRegistrationDetails.preInspectionNumber',
              maxLength:17,
              label: (   <>
                <Text type={'label'}>Pre Inspection Number</Text>
                <Text severity="error"> *</Text>
              </>
        )
            }
          :{
            type: 'text',
            disabled: buyMotorPolicy?.proposalNumber?.length>0
            && !buyMotorPolicy?.isProposalModify,
            colSpan: repeat === repeatForMobile ? 2 : 1,
            name: 'vehicleRegistrationDetails.preInspectionNumber',
            maxLength:17,
            label:  (<>
              <Text type={'label'}>Pre Inspection Number</Text>
                  </>
            ),
          },
          {
            type: 'text',
            disabled: true,
            colSpan: repeat === repeatForMobile ? 2 : 1,
            name: 'vehicleRegistrationDetails.vehicleCategory',
            maxLength:17,
            label:  (<>
              <Text type={'label'}>Vehicle Category</Text>
                  </>
            ),
          }
          // {
          //   type: 'text',
          //   disabled: buyMotorPolicy?.proposalNumber?.length>0,
          //   colSpan: repeat === repeatForMobile ? 2 : 1,
          //   name: 'vehicleRegistrationDetails.preinspectionNumber',
          //   label: (<>
          //           <Text type={'label'}>Pre-Inspection Number</Text>
          //           <Text severity="error"> </Text>
          //         </>
          //   ),
          // },
        ].filter((d) => d),
      },
      {
        title: 'Vehicle Details',
        grid_type: 'data',
        grid_data: [
          {
            label: <>Make</>,

            text: <Text>{values?.vehicleDetails?.make?.value}</Text>,
          },
          {
            label: <>Model</>,

            text: <Text>{values?.vehicleDetails?.model?.value}</Text>,
          },
          {
            label: <>Variant</>,

            text: (
              <Text>{values?.vehicleDetails?.variant?.value}</Text>
            ),
          },
          {
            label: <>Fuel Type</>,
            text: <Text>{values?.vehicleDetails?.fuelType}</Text>,
          },
          {
            label: <>Cubic Capacity</>,
            text: <Text>{values?.vehicleDetails?.cubeCapacity}</Text>,
          },
          {
            label: <>Seating Capacity</>,
            text: (
              <Text>{values?.vehicleDetails?.seatingCapacity}</Text>
            ),
          },
          {
            label: <>Year of Manufacture</>,
            text: (
              <Text>{values?.vehicleDetails?.yearOfManufacture}</Text>
            ),
          },

          {
            label: <>RTO Code (Location)</>,
            text: (
              <Text>{`${
                values?.vehicleDetails?.rtoDetails?.rtoAuthorityCode
              }${
                values?.vehicleDetails?.rtoDetails
                  ?.rtoAuthorityCode &&
                values?.vehicleDetails?.rtoDetails?.rtoLocationDesc
                  ? '-'
                  : ''
              }${
                values?.vehicleDetails?.rtoDetails?.rtoLocationDesc
              }`}</Text>
            ),
          },
          {
            label: <>Date of Registration/Invoice</>,
            text: (
              <Text>
                {values?.vehicleDetails?.dateOfRegistration}
              </Text>
            ),
          },
        ],
      },
      {
        title: 'Insured Declared Value',
        grid_type: 'data',
        grid_data: [
          {
            label: <>Vehicle IDV</>,
            text: (
              <Text>
                {CurrencyFormater(
                  `${values?.insuredDeclaredDetails?.vehicleIDV}`,
                )}
              </Text>
            ),
          },
          {
            label: <>IRF1 Adjustment</>,
            text: values?.insuredDeclaredDetails
              ?.irfAdjustmentPercent ? (
              <Text>{`${values?.insuredDeclaredDetails?.irfAdjustmentPercent} %`}</Text>
            ) : (
              ''
            ),
          },
        ],
      },
    ];

    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };

    return (
      <>
        <QuantaForm className="space-y-4 mt-3">
          <MixedGridGroup {...{ data, ...other_props }} />
        </QuantaForm>
      </>
    );
  };

  const onSubmit = (values) => {
    updateBuyMotorPolicy({
      vehicleTabDetails: {
        ...values,
        vehicleRegistrationDetails: {
          ...values?.vehicleRegistrationDetails,
          registrationNumber: values?.vehicleRegistrationDetails?.registrationNumber === 'NEW'
              ? 'NEW'
              : `${values?.vehicleRegistrationDetails?.registrationNumberParts?.part1}${values?.vehicleRegistrationDetails?.registrationNumberParts?.part2}${values?.vehicleRegistrationDetails?.registrationNumberParts?.part3}${values?.vehicleRegistrationDetails?.registrationNumberParts?.part4}`,
          registrationNumberOthers: values?.vehicleRegistrationDetails?.registrationNumberParts?.part2,
          isProposalRegNoVerified: values?.vehicleRegistrationDetails?.isProposalRegNoVerified
        },
      },
    });
    return true;
  };

  return (
    <div>
      <QuantaFormik
        innerRef={props.forwardedRef}
        enableReinitialize={true}
        {...{
          initialValues,
          validate,
          onSubmit,
          validator: () => ({}),
        }}
      >
        <VehicleDetailsForm {...{ validate }} />
      </QuantaFormik>
    </div>
  );
}
